import { render, staticRenderFns } from "./SupplierProfile.vue?vue&type=template&id=255b1ce8&scoped=true&"
import script from "./SupplierProfile.vue?vue&type=script&lang=js&"
export * from "./SupplierProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b1ce8",
  null
  
)

export default component.exports